import { useMemo, useState } from "react"
import { useSearchParams } from "react-router-dom"

import Column from "../../../common/components/Column"
import { useNavigateUpdatedSearchParams } from "../../../common/utils"
import ActivityReportLogsTable from "../activity-report-logs/ActivityReportLogsTable"
import ActivityReportStatCapsules from "../activity-report-logs/ActivityReportStatCapsules"
import {
  parseActivityReportSearchParams,
  reportDateRangeToSearchParams,
} from "../activity-report-logs/reportDateRangePresets"
import { useActivityReportAnalytics } from "../activity-report-logs/useActivityReportAnalytics"
import AdminPageHeader from "../components/AdminPageHeader"

export default function AdminActivityReportEmails() {
  const [searchParams] = useSearchParams()
  const navigateUpdatedSearchParams = useNavigateUpdatedSearchParams()
  const rangeKey = ["range", "from", "to", "report_date"]
    .map((key) => searchParams.get(key) || "")
    .join("|")
  // The date range lives in the URL (shareable, survives reload).
  const dateRange = useMemo(
    () => parseActivityReportSearchParams(searchParams).analyticsRange,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rangeKey]
  )

  function setDateRange(nextRange) {
    navigateUpdatedSearchParams({
      ...reportDateRangeToSearchParams(nextRange),
      pi: 1,
    })
  }
  const [refreshToken, setRefreshToken] = useState(0)
  const { analytics, loading } = useActivityReportAnalytics(
    dateRange,
    refreshToken
  )

  function handleRefresh() {
    setRefreshToken((token) => token + 1)
  }

  return (
    <Column gap={2}>
      <AdminPageHeader
        title="Activity report emails"
        subtitle="Browse, filter, and send concierge daily activity reports."
        actions={
          <ActivityReportStatCapsules
            analytics={analytics}
            loading={loading}
            compact
          />
        }
      />
      <ActivityReportLogsTable
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
        analytics={analytics}
        analyticsLoading={loading}
        onRefresh={handleRefresh}
      />
    </Column>
  )
}
